<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">CONTENTS</p>
<p class="cct"><span class="epub-sc"><span href="#/xhtml/cover#cover" title="Link target outside of Sample">Cover</span></span></p>
<p class="cct"><span class="epub-sc"><span href="#/xhtml/title#title" title="Link target outside of Sample">Title Page</span></span></p>
<p class="cct"><span class="epub-sc"><span href="#/xhtml/dedication#dedication" title="Link target outside of Sample">Dedication</span></span></p>
<p class="cct"><span class="epub-sc"><a href="#/xhtml/map#map">LIST OF MAPS</a></span></p>
<p class="cct"><span class="epub-sc"><a href="#/xhtml/illustrations#illustrations">LIST OF ILLUSTRATIONS</a></span></p>
<p class="cct"><span class="epub-sc"><a href="#/xhtml/acknowledgments#acknowledgments">ACKNOWLEDGMENTS</a></span></p>
<p class="cct"><span class="epub-sc"><a href="#/xhtml/author#author">AUTHOR’S NOTE</a></span></p>
<p class="cct"><span class="epub-sc"><a href="#/xhtml/frontispiece#frontispiece">Battle of Atlanta Lithograph</a></span></p>
<p class="cct"><a href="#/xhtml/introduction#introduction"><span class="epub-sc">INTRODUCTION</span> “The Dissatisfaction with Mr. Lincoln Grows to Abhorrence”</a></p>
<p class="cct"><a href="#/xhtml/chapter1#ch1">  1. Closing the Vise</a></p>
<p class="cct"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">  2. Prelude</span></p>
<p class="cct"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">  3. The Plan</span></p>
<p class="cct"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">  4. Behind the Lines</span></p>
<p class="cct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">  5. Repulse</span></p>
<p class="cct"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">  6. Sacrifice</span></p>
<p class="cct"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">  7. Two-Sided Fight</span></p>
<p class="cct"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">  8. Bloody Diversion</span></p>
<p class="cct"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">  9. A Human Hurricane on Horseback</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"> 10. Desperation</span></p>
<p class="cct"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample"> 11. Impact</span></p>
<p class="cbmh"><span href="#/xhtml/order#order" title="Link target outside of Sample"><span class="epub-sc">APPENDIX</span> Order of Battle</span></p>
<p class="cbmh"><span class="epub-sc"><span href="#/xhtml/notes#notes" title="Link target outside of Sample">NOTES</span></span></p>
<p class="cbmh"><span class="epub-sc"><span href="#/xhtml/bibliography#bibliography" title="Link target outside of Sample">BIBLIOGRAPHY</span></span></p>
<p class="cbmh"><span class="epub-sc"><span href="#/xhtml/index#index" title="Link target outside of Sample">INDEX</span></span></p>
<p class="cbmh"><span class="epub-sc"><span href="#/xhtml/adcard#adcard" title="Link target outside of Sample">Also By Gary Ecelbarger</span></span></p>
<p class="cbmh"><span class="epub-sc"><span href="#/xhtml/copyright#copyright" title="Link target outside of Sample">Copyright</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?ffadbc84